module.exports = __webpack_public_path__ + "img/abmlLogo.553b64fc.svg";